import * as types from "../types/notification.types";

const initialState = {
  notificationData: [],
  notificationPagination: [],
  notificationFilter: {
    page: 1,
    limit: 10,
  },
  notificationView: [],
  categoriesData: [],
  categoriesPagination: [],
  categoriesFilter: {
    page: 1,
    limit: 10,
  },
  categoriesView: [],
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_NOTIFICATION_LIST_DATA:
      return { ...state, notificationData: action.payload };
    case types.SET_NOTIFICATION_LIST_PAGINATION:
      return { ...state, notificationPagination: action.payload };
    case types.SET_NOTIFICATION_LIST_FILTER:
      return { ...state, notificationFilter: action.payload };
    case types.SET_NOTIFICATION_VIEW_DATA:
      return { ...state, notificationView: action.payload };
    case types.SET_CATEGORIES_LIST_DATA:
      return { ...state, categoriesData: action.payload };
    case types.SET_CATEGORIES_LIST_PAGINATION:
      return { ...state, categoriesPagination: action.payload };
    case types.SET_CATEGORIES_LIST_FILTER:
      return { ...state, categoriesFilter: action.payload };
    case types.SET_CATEGORIES_VIEW_DATA:
      return { ...state, categoriesView: action.payload };


    case types.RESET_NOTIFICATION_REDUCER:
      return { 
        ...state, 
        notificationData: [],
        notificationPagination: [],
        notificationFilter: initialState.notificationFilter,
        notificationView: [],
        categoriesData: [],
        categoriesPagination: [],
        categoriesFilter: initialState.categoriesFilter,
        categoriesView: [],
      };
    default:
      return state;
  }
};
export default NotificationReducer;
